export const B2B_CAMPAIGN_GRACE_PERIOD_HOURS = 36;

export const B2B_CAMPAIGN_REMINDER_DAYS_BEFORE_END = 3;

export const CAMPAIGN_ALLOCATION_FILE_VERSION = '2.1';
export const CAMPAIGN_COMPANY_ALLOCATOR_ALLOCATION_FILE_VERSION = '3.1';
export const CAMPAIGN_COMPANY_ALLOCATOR_ALLOCATION_WITH_MC_FILE_VERSION = '3.1';
export const CAMPAIGN_VACATION_DAYS_ALLOCATION_FILE_VERSION = '1.2';

// Day types as labelled in the "Type de jour*" column of the vacation days allocation amounts file,
// shared by the template export (backend) and the file import (BO)
export const CAMPAIGN_VACATION_DAYS_TYPE_FILE_LABELS = {
  cet: 'Divers',
  rtt: 'RTT',
  overtime: 'Heures supplémentaires',
  paid_leave: 'Congés payés',
  seniority_leave: "Congés d'ancienneté",
  untaken_rest: 'Jours de repos non pris',
} as const;

export const CAMPAIGN_ALLOCATION_FILE_DATA_STARTING_LINE = 3;
export const CAMPAIGN_ALLOCATION_FILE_MAX_LINE = 100000;
